<div class="wrap" [ngClass]="{'fundraiser-page': !vars.pageName.match('stories|mini_story')}">
  <mat-card>
    <div class="title">
      <mat-icon color="primary" class="tl-header-icon icon-users"></mat-icon>
      {{fundraiser?.raised?.backers}} Supporters
    </div>
    <div class="tl-line"></div>
    <div class="place-holder">
      <img loading="lazy" [attr.data-src]="'../assets/images/supporters-list.png'" alt="supporters-list">
      <div class="layout">
        <div class="sub-title">See those who are creating a huge impact and saving lives one donation at a time!</div>
        <app-basic-button
          postIcon="arrow_forward"
          label="{{'Stories.loginDocumentLayout.supportersBtnLable' | translatePipe | async}}"
          [themeConfig]="{bgColor: '#01BFBD', textColor: '#FCFCFC'}"
          (btnClicked)="openLogin()"
        />
      </div>
    </div>
  </mat-card>
</div>

<app-signin-signup [popupView]="true" [numberOnly]="true" [showPopup]="openLoginPopup" [noRedirectAfterLogin]="true" (onClose)="signinClosed()" />
